export const LANGUAGE_VERSIONS = {
   c: "10.2.0", 
   cpp: "10.2.0", 
   csharp: "6.12.0",
   java: "15.0.2",
   javascript: "18.15.0",
  // typescript: "5.0.3",
   php: "8.2.3",
   python: "3.10.0",
 
};

export const CODE_SNIPPETS = {
  javascript: `\nfunction greet(name) {\n\tconsole.log("Hello, " + name + "!");\n}\n\ngreet("Alex");\n`,
  // typescript: `\ntype Params = {\n\tname: string;\n}\n\nfunction greet(data: Params) {\n\tconsole.log("Hello, " + data.name + "!");\n}\n\ngreet({ name: "Alex" });\n`,
  python: `\ndef greet(name):\n\tprint("Hello, " + name + "!")\n\ngreet("Alex")\n`,
  java: `\npublic class HelloWorld {\n\tpublic static void main(String[] args) {\n\t\tSystem.out.println("Hello World");\n\t}\n}\n`,
  csharp:
    'using System;\n\nnamespace HelloWorld\n{\n\tclass Hello { \n\t\tstatic void Main(string[] args) {\n\t\t\tConsole.WriteLine("Hello World in C#");\n\t\t}\n\t}\n}\n',
  php: "<?php\n\n$name = 'Alex';\necho $name;\n",
  
  c:  `
  #include <stdio.h>
  int main() {
      printf("Hello, World in C!\\n");
      return 0;
  }
  `,
  cpp: `
#include <iostream>
using namespace std;
int main() {
    cout << "Hello, World in C++!" << endl;
    return 0;
}
`,
};
